import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  className = '' 
}) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-b-2 border-clinic-primary ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
        data-testid="loading-spinner"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export { LoadingSpinner };
export default LoadingSpinner;